import { FC } from "react";
import { utils } from "@vilocnv/allsetra-core";
import { Stack, Typography } from "@mui/material";
import { CalendarIcon, ClockIcon } from "./ObjectDevicesCard.styled";
import { useTranslation } from "react-i18next";

export interface LabelsBatteryInstallationDatesProps {
  installationDate: Date;
  lifetimeDays: number;
}

const LabelsBatteryInstallationDates: FC<
  LabelsBatteryInstallationDatesProps
> = ({ installationDate, lifetimeDays }) => {
  const { t } = useTranslation();
  if (!installationDate || !lifetimeDays) return null;

  const getUsageTimeLeft = (
    installationDate: Date | undefined,
    lifetimeDays: number,
    translator: any
  ) => {
    if (!installationDate || !lifetimeDays) return null;

    const expirationDate = new Date(installationDate);
    expirationDate.setDate(expirationDate.getDate() + lifetimeDays);
    const today = new Date();
    const diffTime = expirationDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) {
      return "Battery lifetime ended";
    } else if (diffDays >= 365) {
      let years = Math.floor(diffDays / 365);
      let months = Math.floor((diffDays % 365) / 30);
      if (months === 12) {
        years += 1;
        months = 0;
      }
      if (months > 0) {
        return `${years} ${years === 1 ? translator("dateFormatsLowerCase.year") : translator("dateFormatsLowerCase.years")} and ${months} ${months === 1 ? translator("dateFormatsLowerCase.month") : translator("dateFormatsLowerCase.months")} ${translator("ofUsageLeft")}`;
      } else {
        return `${years} ${years === 1 ? translator("dateFormatsLowerCase.year") : translator("dateFormatsLowerCase.years")} ${translator("ofUsageLeft")}`;
      }
    } else if (diffDays >= 30) {
      const months = Math.floor(diffDays / 30);
      return `${months} ${months === 1 ? translator("dateFormatsLowerCase.month") : translator("dateFormatsLowerCase.months")} ${translator("ofUsageLeft")}`;
    } else if (diffDays >= 7) {
      const weeks = Math.floor(diffDays / 7);
      return `${weeks} ${weeks === 1 ? translator("dateFormatsLowerCase.week") : translator("dateFormatsLowerCase.weeks")} ${translator("ofUsageLeft")}`;
    } else {
      return `${diffDays} ${diffDays === 1 ? translator("dateFormatsLowerCase.day") : translator("dateFormatsLowerCase.days")} ${translator("ofUsageLeft")}`;
    }
  };
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Stack direction={"row"} alignItems={"center"} spacing={1}>
        <ClockIcon />
        <Typography fontSize={14} fontWeight={400} color={"#646D7B"}>
          {getUsageTimeLeft(installationDate, lifetimeDays, t)}
        </Typography>
      </Stack>
      <Stack direction={"row"} alignItems={"center"} spacing={1}>
        <CalendarIcon />
        <Typography fontSize={14} fontWeight={400} color={"#646D7B"}>
          Installed on{" "}
          {utils.formatDate({
            date: installationDate,
            dateFormat: "dd MMM yyyy"
          })}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default LabelsBatteryInstallationDates;
